module.exports = function getResource(label, vars = []) {
    let resources = {
        community: 'Community',
        profile: 'Profile',
        groups: 'Groups',
        gallery: 'Gallery',
        communityNavigation: 'Community Navigation',
        notificationsFeed: 'Notifications Feed',
        startAConversation: 'Start a Conversation',
        addAPhoto: 'Add a Photo',
        messages: 'Messages'
    };
    return resources[label];
};
